// src/services/authService.js
import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getFormat = async () => {
    return userRequest.get(`${DOMAIN}/api/format`);
  };

export const postFormat = async (data) => {
  console.log(data)
  return userRequest.post(`${DOMAIN}/api/format`, data);
};